import React, { FC } from 'react'

import { ITagProps, ETagTypes } from './types'
import { StyledTag } from './styled'

export const Tag: FC<ITagProps> = (props) => (
  <StyledTag {...props}>{ETagTypes[props.type]}</StyledTag>
)
